import customAxios from './axios';
import { PRODUCT_TAG_PREFIX_NAME_V1 } from "../constants/api";

export function getByPrefixWithProductSkuId(prefixName) {
    return customAxios.get(PRODUCT_TAG_PREFIX_NAME_V1(prefixName));
}